import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { getToken } from "@/utils/auth"

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/withdrawal',
    name: 'Withdrawal',
    component: () => import('../views/withdrawal/index.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register/index.vue')
  },
  {
    path: '/information',
    name: 'Information',
    component: () => import('../views/information/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const whiteList = [ '/', '/login', '/register', '/information']

router.beforeEach((to, from, next)=>{
  const tokenStr = getToken()
  if(tokenStr){
    if(to.path === '/login'){
      next({ path: '/' })
    }else{
      next()
    }
  }else{
    if (whiteList.indexOf(to.path) !== -1){
      next()
    }else{
      next(`/login?redirect=${to.path}`)
    }
  }
})

export default router
